import React, { useState } from "react";
import { Link, useParams, useNavigate } from "react-router-dom";
import Header from "./Header";
import Footer from "./Footer";
import productData from "../Datas/productData";
import "../css/aftersales.scss";

const Aftersales = () => {
  const { orderId, type } = useParams();
  const navigate = useNavigate();
  const [requestType, setRequestType] = useState(type || "refund");
  const [reason, setReason] = useState("");
  const [description, setDescription] = useState("");
  const [images, setImages] = useState([]);
  const [loading, setLoading] = useState(false);

  const requestTypes = [
    { id: "refund", label: "Refund", description: "Request a full or partial refund" },
    { id: "return", label: "Return", description: "Return the item for a refund" },
    { id: "exchange", label: "Exchange", description: "Exchange for a different size or item" },
  ];

  const reasons = [
    "Item does not match the description",
    "Received wrong item",
    "Item damaged or defective",
    "Size does not fit",
    "Changed mind",
    "Other",
  ];

  const mockOrderItems = [
    { productId: 101, quantity: 1, size: "5-6Y", price: 499.0 },
    { productId: 102, quantity: 1, size: "5-6Y", price: 559.0 },
  ];

  const orderProducts = mockOrderItems.map((item) => {
    const product = productData.find((p) => p.id === item.productId);
    return product ? { ...product, ...item } : null;
  }).filter(Boolean);

  const handleImageUpload = (e) => {
    const files = Array.from(e.target.files);
    if (images.length + files.length > 5) {
      alert("Maximum 5 images allowed");
      return;
    }
    const newImages = files.map((file) => URL.createObjectURL(file));
    setImages([...images, ...newImages]);
  };

  const removeImage = (index) => {
    setImages(images.filter((_, i) => i !== index));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!reason) {
      alert("Please select a reason");
      return;
    }
    setLoading(true);
    setTimeout(() => {
      setLoading(false);
      alert("Request submitted successfully");
      navigate("/orders");
    }, 1500);
  };

  const toTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  return (
    <div className="aftersales-page color-scheme color-scheme--scheme-1">
      <Header />
      <main className="aftersales-page__main">
        <div className="aftersales-container">
          <div className="aftersales-header">
            <Link to="/orders" className="back-link" onClick={toTop}>
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" width="20" height="20">
                <path strokeLinecap="round" strokeLinejoin="round" d="M15.75 19.5L8.25 12l7.5-7.5" />
              </svg>
              Back to Orders
            </Link>
            <h1 className="aftersales-title">Request After-Sales Service</h1>
          </div>

          <form className="aftersales-form" onSubmit={handleSubmit}>
            <section className="form-section">
              <h2 className="section-title">Select Request Type</h2>
              <div className="request-types">
                {requestTypes.map((type) => (
                  <button
                    key={type.id}
                    type="button"
                    className={`request-type-card ${requestType === type.id ? "is-selected" : ""}`}
                    onClick={() => setRequestType(type.id)}
                  >
                    <div className="type-icon">
                      {type.id === "refund" && (
                        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" width="24" height="24">
                          <path strokeLinecap="round" strokeLinejoin="round" d="M12 6v12m-3-2.818l.879.659c1.171.879 3.07.879 4.242 0 1.172-.879 1.172-2.303 0-3.182C13.536 12.219 12.768 12 12 12c-.725 0-1.45-.22-2.003-.659-1.106-.879-1.106-2.303 0-3.182s2.9-.879 4.006 0l.415.33M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                        </svg>
                      )}
                      {type.id === "return" && (
                        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" width="24" height="24">
                          <path strokeLinecap="round" strokeLinejoin="round" d="M9 15L3 9m0 0l6-6M3 9h12a6 6 0 010 12h-3" />
                        </svg>
                      )}
                      {type.id === "exchange" && (
                        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" width="24" height="24">
                          <path strokeLinecap="round" strokeLinejoin="round" d="M7.5 21L3 16.5m0 0L7.5 12M3 16.5h13.5m0-13.5L21 7.5m0 0L16.5 12M21 7.5H7.5" />
                        </svg>
                      )}
                    </div>
                    <div className="type-info">
                      <h3>{type.label}</h3>
                      <p>{type.description}</p>
                    </div>
                    <div className="type-check">
                      {requestType === type.id && (
                        <svg viewBox="0 0 24 24" fill="currentColor" width="20" height="20">
                          <path fillRule="evenodd" d="M2.25 12c0-5.385 4.365-9.75 9.75-9.75s9.75 4.365 9.75 9.75-4.365 9.75-9.75 9.75S2.25 17.385 2.25 12zm13.36-1.814a.75.75 0 10-1.22-.872l-3.236 4.53L9.53 12.22a.75.75 0 00-1.06 1.06l2.25 2.25a.75.75 0 001.14-.094l3.75-5.25z" clipRule="evenodd" />
                        </svg>
                      )}
                    </div>
                  </button>
                ))}
              </div>
            </section>

            <section className="form-section">
              <h2 className="section-title">Select Items</h2>
              <div className="order-items">
                {orderProducts.map((product) => (
                  <div key={product.id} className="order-item">
                    <div className="item-image">
                      <img src={product.images[0]} alt={product.name} />
                    </div>
                    <div className="item-info">
                      <p className="item-name">{product.name}</p>
                      <p className="item-meta">Size: {product.size} | Qty: {product.quantity}</p>
                      <p className="item-price">€ {product.price.toFixed(2)}</p>
                    </div>
                    <label className="item-checkbox">
                      <input type="checkbox" defaultChecked />
                      <span className="checkmark" />
                    </label>
                  </div>
                ))}
              </div>
            </section>

            <section className="form-section">
              <h2 className="section-title">Reason for Request</h2>
              <div className="reason-options">
                {reasons.map((r) => (
                  <label key={r} className={`reason-option ${reason === r ? "is-selected" : ""}`}>
                    <input
                      type="radio"
                      name="reason"
                      value={r}
                      checked={reason === r}
                      onChange={(e) => setReason(e.target.value)}
                    />
                    <span className="reason-text">{r}</span>
                  </label>
                ))}
              </div>
            </section>

            <section className="form-section">
              <h2 className="section-title">Additional Details (Optional)</h2>
              <textarea
                className="description-input"
                placeholder="Please describe your issue in detail..."
                value={description}
                onChange={(e) => setDescription(e.target.value)}
                rows={4}
              />
            </section>

            <section className="form-section">
              <h2 className="section-title">Upload Images (Optional)</h2>
              <p className="section-hint">Upload up to 5 images to help us understand your issue</p>
              <div className="image-upload">
                <div className="uploaded-images">
                  {images.map((img, index) => (
                    <div key={index} className="uploaded-image">
                      <img src={img} alt={`Upload ${index + 1}`} />
                      <button
                        type="button"
                        className="remove-image"
                        onClick={() => removeImage(index)}
                      >
                        <svg viewBox="0 0 24 24" fill="currentColor" width="16" height="16">
                          <path fillRule="evenodd" d="M12 2.25c-5.385 0-9.75 4.365-9.75 9.75s4.365 9.75 9.75 9.75 9.75-4.365 9.75-9.75S17.385 2.25 12 2.25zm-1.72 6.97a.75.75 0 10-1.06 1.06L10.94 12l-1.72 1.72a.75.75 0 101.06 1.06L12 13.06l1.72 1.72a.75.75 0 101.06-1.06L13.06 12l1.72-1.72a.75.75 0 10-1.06-1.06L12 10.94l-1.72-1.72z" clipRule="evenodd" />
                        </svg>
                      </button>
                    </div>
                  ))}
                  {images.length < 5 && (
                    <label className="upload-btn">
                      <input
                        type="file"
                        accept="image/*"
                        multiple
                        onChange={handleImageUpload}
                        hidden
                      />
                      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" width="24" height="24">
                        <path strokeLinecap="round" strokeLinejoin="round" d="M12 4.5v15m7.5-7.5h-15" />
                      </svg>
                      <span>Add Photo</span>
                    </label>
                  )}
                </div>
              </div>
            </section>

            <div className="form-actions">
              <button type="button" className="cancel-btn" onClick={() => navigate("/orders")}>
                Cancel
              </button>
              <button type="submit" className="submit-btn" disabled={loading}>
                {loading ? "Submitting..." : "Submit Request"}
              </button>
            </div>
          </form>
        </div>
      </main>
      <Footer />
    </div>
  );
};

export default Aftersales;
